import { Request } from './Request';

export interface IGetApiTokenRequestParam {
}

export class GetApiTokenRequest extends Request<IGetApiTokenRequestParam, any> {
  constructor(params: IGetApiTokenRequestParam = {}) {
    super('getApiTokens', params);
  }
}

